export function getWowheadTalentCalcUrl(loadoutText: string): string {
  return `https://www.wowhead.com/talent-calc/blizzard/${encodeURIComponent(loadoutText)}`;
}
